import { render, staticRenderFns } from "./app-header-global-search-loading.vue?vue&type=template&id=2eab0928&"
import script from "./app-header-global-search-loading.vue?vue&type=script&lang=ts&"
export * from "./app-header-global-search-loading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports